import React from 'react';
import './HelpCenter.css';

const HelpCenter = ({ onBack }) => {
  const faqs = [
    { q: "How do I track my order?", a: "You can track your order by visiting the 'Orders' section in your profile and clicking on the specific order." },
    { q: "What is the return policy?", a: "We have a 14-day return policy for all items. Ensure the tags are intact and the item is unused." },
    { q: "How can I cancel my order?", a: "Orders can be cancelled before they are shipped. Visit the 'Orders' section to find the cancel button." },
    { q: "Do you ship internationally?", a: "Currently, we only ship within India. Stay tuned for international updates!" },
  ];

  return (
    <div className="help-page container">
      <div className="help-header">
        <button className="back-link" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          Back
        </button>
        <h1>Help Center</h1>
        <p>Frequently Asked Questions & Support</p>
      </div>

      <div className="help-content">
        <div className="faq-section">
          {faqs.map((faq, i) => (
            <div key={i} className="faq-card">
              <h3>{faq.q}</h3>
              <p>{faq.a}</p>
            </div>
          ))}
        </div>

        <div className="contact-section card">
          <h2>Still need help?</h2>
          <div className="contact-methods">
            <div className="method">
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
              <p>Email us at: support@below2000.com</p>
            </div>
            <div className="method">
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>
              <p>Call us: 1800-123-4567</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
